import { isValidPhoneNumber } from 'libphonenumber-js';
import { FormGroup, ValidationErrors, Validators } from '@angular/forms';

export function phoneValidator(control: FormGroup): ValidationErrors | null {
  const callingCode = control.controls.extension?.value;
  const numberValue = control.controls.digits?.value;
  const required = control.hasValidator(Validators.required);
  // not required
  // if numberValue is empty do not return an error
  if (!required && (!numberValue || numberValue === '')) {
    return null;
  }
  // required
  return !callingCode ||
    (
      !numberValue ||
      numberValue === '' ||
      !isValidPhoneNumber(callingCode + numberValue)
    )
    ? { wrongPhoneNumber : true } : null ;
}

